import {WGStackAnimationView} from "./WGStackAnimationView";
import {TimelineLite} from "gsap";

export class WGStackAnimationController {
    private _view: WGStackAnimationView;

    constructor() {
        this._view = new WGStackAnimationView();
    }

    /**
     * function to play wild idle stack animation
     */
    public playWildStackAnimation(reelId: number, animType: string): TimelineLite {
        return this._view.playWildAnimation(reelId, animType);
    }

    public playMidStackIdleAnimation(reelId: number, symbolId: number, symName: string): TimelineLite {
        let tint = 0xFFFFFF;
        let playDouble: boolean = false;
        switch (symName) {
            case "M1":
                tint = 0xFF3529;
                playDouble = true;
                break;
            case "M2":
                tint = 0xFFF142;
                break;
            case "M3":
                tint = 0x89F8C1;
                break;
            case "M4":
                tint = 0x8FFFFF;
                break;
            case "M5":
                tint = 0xFFFFFF;
                break;
        }
        return this._view.playMidStackIdleAnimation(reelId, symbolId, tint, playDouble);
    }

    public playAliveMidStackWinAnimation(reelIds: boolean[], symbolName: string): void {
        let reels: number[] = [];
        for (let i: number = 0; i < reelIds.length; i++) {
            if (reelIds[i]) {
                reels.push(i)
            }
        }
        this._view.playAliveMidStackWinAnimation(reels, symbolName);
    }

    public hideALlWinMidStack(): void {
        this._view._aliveMidStackWinAnimation.forEach(value => {
            value.visible = false
        });
    }

    /**
     * function to hide all stack Animations
     */
    public hideAllStackAnimation() {
        this._view.hideallWildStackAnimation();
        this._view.clearMidStackIdleAnimation();
    }
}